import React, { useState, useEffect } from 'react';
import { API_DOMAIN } from './globals'; // Import the global domain name

function Statements() {

    const [myStatements, setStatements] = useState([]);  // Store the API response
    const [loading, setLoading] = useState(true);  // Loading state
    const [error, setError] = useState(null);  // Error state

    const formatDateWithDashes = (date) => {
        const d = new Date(date);
        const day = d.getDate().toString().padStart(2, '0');
        const month = (d.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

  useEffect(() => {
    // Define your parameters
    const param1 = sessionStorage.getItem("UserType");
    const param2 = sessionStorage.getItem("UserName");

    // Create an object to pass parameters to the GET request
    const params = {
      ut: param1,
      un: param2,
    };

    const queryString = new URLSearchParams(params).toString();
    const url = `${API_DOMAIN}/api/Client/getMyStatements.php?${queryString}`;

    fetch(url, {
        method: 'GET',
        credentials: 'include', // Equivalent to withCredentials:true
        headers: {
            'Content-Type': 'application/json',
        },
    })
    .then(response => response.json())
    .then(data => {
        if(data.Status=="Error") {
            sessionStorage.setItem("LogoutMsg",data.Message)
            window.location = '/';
        } else {
            //console.log(data.data);
            setStatements(data.data); // Save the response data in state
        }
        setLoading(false); // Set loading to false
    })
    .catch(err => {
        setError(err); // Save any error to the state
        setLoading(false); // Set loading to false
    });

  }, []);  // Empty dependency array ensures this runs only once when the component mounts

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

    return (
        <>
            <section className="accountste match-content">
                <div className="table_tittle" style={{ background: 'linear-gradient(to right, #622569, #d54be4)',color:'white'}}>Account Statements</div>
                <div className="col-md-12"></div>
                <div id="divLoading"></div>
                <div className="appendAjaxTbl">
                    <div className="table-responsive sports-tabel">
                        <table className="table table-bordered table-hover" id="datatabless">
                            <thead>
                                <tr style={{ background: '#000',color:'white'}}>
                                    <th className="">S.No. </th>
                                    <th className="">Date </th>
                                    <th className="">Description </th>
                                    <th className="rrig text-right">Prev. Bal </th>
                                    <th className="rrig text-right">Credit</th>
                                    <th className="rrig text-right">Debit </th>
                                    <th className="rrig text-right">Balance </th>
                                </tr>
                            </thead>
                            <tbody>
                                {myStatements.map((row, index) => (
                                <tr key={index}>
                                    <td style={{color:'black'}}>{index + 1}</td>

                                    <td style={{color:'black'}}>{formatDateWithDashes(row.DateTime) } {new Date(row.DateTime).toLocaleTimeString("en-GB", { hour: "2-digit",minute: "2-digit",second: "2-digit",hour12: true }).toUpperCase()}</td>
                                    <td className=" " style={{color:'black'}}>
                                        <a title="show bet">{row.WonLoss } {row.WonLoss!='' ? '-' :''} {row.Remark}</a>
                                    </td>
                                    <td className=" text-right" style={{fontWeight:'bold',color:'black'}}>{row.PrevBalance}</td>
                                    <td className="green text-right" style={{fontWeight:'bold',color:'black'}}>{row.Credit}</td>
                                    <td className="red text-right" style={{fontWeight:'bold',color:'black'}}>{row.Debit}</td>
                                    <td className=" text-right" style={{fontWeight:'bold',color:'black'}}>{row.Balance}</td>
                                </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Statements;
